import rest from '../rest';
import { contractTeamsCount, contractTeamsTemplateMarker, appointmentTeamsByGrouping } from './teamsResponse';
import { data } from './data';

const teams = [
	rest.get(`/api/v2/contracts/teams/count/:year/:types`, (req, res, ctx) => res(ctx.json(contractTeamsCount))),
	rest.get(`/api/v2/contracts/teams/template/:appointeeType`, (req, res, ctx) => {
		const { appointeeType } = req.params;
		switch (appointeeType.toLowerCase()) {
			case 'marker':
				return res(ctx.json(contractTeamsTemplateMarker));
			default:
				throw new Error('Unhandled Appointee Type');
		}
	}),
	rest.get(`/api/v2/contracts/teams/:year/:types`, (req, res, ctx) => res(ctx.json(data))),
	rest.get('/api/v2/appointments/teams/:year/:grouping', (req, res, ctx) => {
		let { grouping } = req.params;
		grouping = decodeURIComponent(grouping);
		const content = {
			status: 200,
			data: appointmentTeamsByGrouping[grouping] || { count: 0, data: [], error: []},
		};
		return res(ctx.json(content));
	})
];

export default teams;
